import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

export default function FargoPage() {
  return (
    <>
      <CitySEOHead
        city="Fargo"
        state="North Dakota"
        stateAbbr="ND"
        route="/cities/fargo"
        title="Emergency Passport Fargo, ND — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Fargo, North Dakota. Serving Cass County, West Fargo, Moorhead, and Red River Valley communities. As fast as 24 hours — no Chicago agency trip needed."
        geoPlacename="Fargo, North Dakota"
        geoPosition="46.8772;-96.7898"
        faqs={[]}
        servicesSchema={[]}
        statePageName="North Dakota"
        statePageRoute="/states/north-dakota"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <LocalAreaSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}